import React, { useState, useEffect, useContext } from 'react';
import './style.css';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { Wrench, CirclePercent, ChevronsRight, Percent, Receipt, PiggyBank, TrendingUpDown, Tag } from 'lucide-react';
import { WindowSizeContext } from '/src/App';

const ProjectsSummaryData = ({
    projects_list = [],
    propertyData,
    direction = 'vertical',
    isBigPicture = false
}) => {

    const { deviceType } = useContext(WindowSizeContext);

    // Get property areas threatened, projects list, number of projects, total discounts, and climate risks
    // const property_areas_threatened = propertyData?.data?.property_areas_threatened?.house_categories_with_risks || [];
    // const projects_list = propertyData?.data?.recommended_projects?.projects_list || [];

    const addressStreet = propertyData?.data?.property_details?.street;
    const addressText = addressStreet ? `${addressStreet} Summary` : "Summary for this Home";


    const total_num_projects = projects_list.length;
    const total_num_discounts = projects_list?.reduce((sum, project) =>
        sum + (Array.isArray(project.project_discounts_master) ? project.project_discounts_company_specific.length : 0), 0) || 0;

    // console.log(total_num_discounts);
    // Get the total cost of all projects and the total value of all projects
    const total_cost_of_all_projects = projects_list.reduce((sum, project) => sum + project.project_total_cost, 0);
    const total_value_of_all_projects = projects_list.reduce((sum, project) => sum + project.project_payoff_by_scenario[0].by_total.total, 0);
    const total_roi_of_all_projects = ((total_value_of_all_projects - total_cost_of_all_projects) / total_cost_of_all_projects) * 100;

    // Set the icon size
    const icon_size = direction === 'summary' ? 16 : 28;

    // Handler to format dollar value into K and M values
    const formatDollarValue = (value) => {
        if (value >= 1000000) {
            return `$${(value / 1000000).toFixed(1)}M`;
        } else if (value >= 1000) {
            return `$${(value / 1000).toFixed(1)}K`;
        } else {
            return `$${value.toFixed(0)}`;
        }
    }

    const street_address = propertyData?.data?.property_details?.street || "this home"



    // Create the array of the datapoints for display
    const datapoints = [
        {
            title: 'Recommended Home Improvements',
            value: total_num_projects,
            icon: <Wrench size={icon_size} />
        },
        {
            title: 'Discounts, Rebates, and Incentives Identified',
            value: total_num_discounts,
            icon: <Tag size={icon_size} />
        },
        {
            title: 'Est. Cost of All Projects',
            value: formatDollarValue(total_cost_of_all_projects),
            icon: <Receipt size={icon_size} />
        },
        {
            title: 'Est. Benefit to You From All Projects',
            value: formatDollarValue(total_value_of_all_projects),
            icon: <PiggyBank size={icon_size} />
        },
        {
            title: 'Est. ROI Across All Projects',
            value: `${total_roi_of_all_projects.toFixed(0)}x`,
            icon: <TrendingUpDown size={icon_size} />
        }
    ]

    // Vertical datapoints are grouped into 2 or 3 columns
    const vertical_datapoints = [
        [
            datapoints[0],
            datapoints[1]
        ],
        [
            datapoints[2],
            datapoints[3],
            datapoints[4]
        ]
    ]

    // Big Picture datapoints are grouped into 2 or 3 columns
    const big_picture_datapoints = [
        [
            datapoints[0],
            datapoints[3],
            datapoints[1]
        ]
    ]

    const verticalDatapointsToUse = isBigPicture ? big_picture_datapoints : vertical_datapoints;

    return (
        <>
            {(direction === 'horizontal' || direction === 'sidebar') && (
                <div className={`view-projects__totals ${direction}`}>
                    {datapoints.map((datapoint, index) => (
                        <>
                            <div key={datapoint.title} className="view-projects__total-item">
                                {/* <h3 className="view-projects__total-title text-align-center">{datapoint.title}</h3> */}
                                <div className="view-projects__total-value">
                                    <div className="view-projects__total-value-icon-container">
                                        {datapoint.icon}
                                    </div>
                                    <span>{datapoint.value}</span>
                                </div>
                            </div>
                        </>
                    ))
                    }

                </div>
            )}
            {direction === 'vertical' && (
                <div className={`view-projects__totals ${direction}`}>
                    {!isBigPicture && (
                        <div className="view-projects__totals-title-container">
                            <h3 className="view-projects__totals-title text-align-center">{addressText}</h3>
                        </div>
                    )}
                    {verticalDatapointsToUse.map((datapoints, index) => {

                        const numColumns = (deviceType === 'mobile') ? 1 : datapoints.length;

                        return (
                            <div key={index} className={`view-projects__totals-vertical-${numColumns}-column`}>
                                {datapoints.map((datapoint, index) => {

                                    return (
                                        <div key={datapoint.title} className="view-projects__total-item">
                                            <h3 className="view-projects__total-title text-align-center">{datapoint.title}</h3>
                                            <div className="view-projects__total-value">
                                                {datapoint.icon}
                                                <span>{datapoint.value}</span>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        )
                    })
                    }

                </div>
            )}
            {direction === 'summary' && (
                <div className={`view-projects__totals summary`}>
                    {datapoints.map((datapoint, index) => (
                        <>
                            <div key={datapoint.title} className="view-projects__total-item">
                                {/* <h3 className="view-projects__total-title text-align-center">{datapoint.title}</h3> */}
                                <div className="view-projects__total-value">
                                    {datapoint.icon}
                                    <span>{datapoint.value}</span>
                                </div>
                            </div>
                        </>
                    ))
                    }

                </div>
            )}
        </>
    );
};

export default ProjectsSummaryData;